import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import NewModifyCourse from "../views/NewModifyCourse.vue";
import CreateCourse from "../views/CreateCourse.vue";
import StudentWelcome from "../views/StudentWelcome.vue";
import TeacherWelcome from "../views/TeacherWelcome.vue";
import Login from "../views/Login.vue";
import About from "../views/About.vue";
import Verify from "../views/Verify";
import Schedule from "../views/Schedule";
import Profile from "../views/ProfilePage";
import Admin from "../views/Admin";
import store from "../store";
import Leodata from "../views/Leodata.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/modify-course/:id",
    name: "ModifyCourse",
    component: NewModifyCourse,
  },
  {
    path: "/backdoor",
    name: "Backdoor",
    component: Login,
  },
  {
    path: "/student-welcome",
    name: "StudentWelcome",
    component: StudentWelcome,
  },
  {
    path: "/teacher-welcome",
    name: "TeacherWelcome",
    component: TeacherWelcome,
  },
  {
    path: "/createcourse",
    name: "CreateCourse",
    component: CreateCourse,
  },
  {
    path: "/createcourse/:memberid",
    name: "CreateCourseAdmin",
    component: CreateCourse,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/verify",
    name: "Verify",
    component: Verify,
  },
  {
    path: "/edt",
    name: "Schedule",
    component: Schedule,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/member/:memberid",
    name: "Member",
    component: Profile,
    meta: { requiresAdmin: true },
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: { requiresAdmin: true },
  },
  {
    path: "/leodata",
    name: "LeodataRoot",
    component: Leodata,
  },
  {
    path: "/leodata/:pathMatch(.*)*",
    name: "LeodatPath",
    component: Leodata,
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters["user/loginState"];
  const isAdmin = store.getters["user/isAdmin"];

  const DEFAULT_PAGE = "/profile";

  // Pages accessibles à tous
  const publicPages = ["/about"];
  if (publicPages.includes(to.path)) {
    return next();
  }

  // Pages accessibles seulement par les non-connectés
  const notLoggedInPages = ["/", "/backdoor", "/verify"];
  if (notLoggedInPages.includes(to.path)) {
    if (isLoggedIn && to.path !== DEFAULT_PAGE) return next(DEFAULT_PAGE);
    return next();
  }

  // Pages accessibles seulement par les connectés
  if (!isLoggedIn) {
    sessionStorage.setItem("redirectPath", to.fullPath);
    console.log(sessionStorage.getItem("redirectPath"));
    return next("/");
  }

  if (to.meta.requiresAdmin && !isAdmin) {
    if (to.path !== DEFAULT_PAGE) {
      return next(DEFAULT_PAGE);
    }
    return next();
  }

  return next();
});

// /[unepagequiexiste]
//    si pas connecté => next("/") + sessionStorage.setItem("redirectPath", to.fullPath);
//    si connecté
//      si !to.meta.requiresAdmin || isAdmin => next()
//      sinon => next("/profile")
// /, /backdoor, /verifty
//    si connecté => next("/profile")
//    si pas connecté => next()
// /about
//    next()

export default router;
